import { TYPES } from "./bailiff_document.type";

const initState = {
  bailiffDocumentAll: null,
  bailiffDocumentOpenAdd: false,
  bailiffDocumentOpenEdit: false,
  bailiffDocumentSelected: null,
  bailiffDocumentSearch: "",
  //
  bailiffDocumentDetail: null,
  bailiffDocumentRaw: null,
  //extracing.
  bailiffDocumentExtractingCount: 0,

  //
  bailiffDocumentSort: "asc",
  // dialog
  bailiffDocumentOpenPay: false,
  bailiffDocumentOpenUpload: false,
  bailiffDocumentStep: 0, // user for ver 2
  bailiffDocumentUploadComplete: false,
  bailiffDocumentProcessComplete: false, // use for ver 2.
  // ffmpeg
  bailiffDocumentPercentUpload: 0,
  bailiffDocumentPercentProcess: 0,
  bailiffDocumentAudio: { file: null, fileName: "" },
  bailiffDocumentAudioDuration: 0,
  // deposit.
  bailiffDocumentDepositJobId: null,
};

const bailiffDocumentReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_BAILIFF_DOCUMENT_ALL:
      return {
        ...state,
        bailiffDocumentAll: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_OPEN_ADD:
      return {
        ...state,
        bailiffDocumentOpenAdd: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_OPEN_EDIT:
      return {
        ...state,
        bailiffDocumentOpenEdit: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_SELECTED:
      return {
        ...state,
        bailiffDocumentSelected: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_EXTRACTING_COUNT:
      return {
        ...state,
        bailiffDocumentExtractingCount: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_SEARCH:
      return {
        ...state,
        bailiffDocumentSearch: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_DETAIL:
      return {
        ...state,
        bailiffDocumentDetail: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_RAW:
      return {
        ...state,
        bailiffDocumentRaw: payload,
      };
    //
    case TYPES.SET_BAILIFF_DOCUMENT_SORT:
      return {
        ...state,
        bailiffDocumentSort: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_OPEN_PAY:
      return {
        ...state,
        bailiffDocumentOpenPay: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_OPEN_UPLOAD:
      return {
        ...state,
        bailiffDocumentOpenUpload: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_STEP:
      return {
        ...state,
        bailiffDocumentStep: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_AUDIO:
      return {
        ...state,
        bailiffDocumentAudio: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_AUDIO_DURATION:
      return {
        ...state,
        bailiffDocumentAudioDuration: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_PER_UPLOAD:
      return {
        ...state,
        bailiffDocumentPercentUpload: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_PER_PROGRESS:
      return {
        ...state,
        bailiffDocumentPercentProcess: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_UPLOAD_COMPLETE:
      return {
        ...state,
        bailiffDocumentUploadComplete: payload,
      };

    case TYPES.SET_BAILIFF_DOCUMENT_PROCCESS_COMPLETE:
      return {
        ...state,
        bailiffDocumentProcessComplete: payload,
      };
    //
    case TYPES.SET_BAILIFF_DOCUMENT_DEPOSIT_JOB_ID:
      return {
        ...state,
        bailiffDocumentDepositJobId: payload,
      };

    default:
      return state;
  }
};

export default bailiffDocumentReducer;
